import { render, staticRenderFns } from "./Configurator.vue?vue&type=template&id=16652ac2"
import script from "./Configurator.vue?vue&type=script&lang=js"
export * from "./Configurator.vue?vue&type=script&lang=js"
import style0 from "./Configurator.vue?vue&type=style&index=0&id=16652ac2&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ConfiguratorHeadlightType: require('/app/components/ConfiguratorHeadlightType.vue').default,ConfiguratorHeadlightBlock: require('/app/components/ConfiguratorHeadlightBlock.vue').default})
